import React, { useState } from 'react';
import MainToolbar from '../MainToolbar';
import { TableContainer, Table, TableRow, TableCell, TableHead, TableBody, makeStyles, IconButton, Paper } from '@material-ui/core';
import t from '../common/localization';
import { useEffectAsync } from '../reactHelper';
import EditCollectionView from '../EditCollectionView';
import { prefixString } from '../common/stringUtils';
import { formatBoolean } from '../common/formatter';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import { green, blue, red, grey } from '@material-ui/core/colors';
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "material-ui-search-bar";

const useStyles = makeStyles(theme => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
      backgroundColor: 'white',
    },
    rowAction: {
       backgroundColor: '#361DDB',
    },
   iconButtons: {
          marginLeft: 'auto',
          display: 'flex',
    },
    small: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        backgroundColor:'#EFEFEF',
        margin: '2px'
      },
      tableRow: {
            "&$hover:hover": {
            backgroundColor: "#FFFFFF"
            }
          },
          tCell: {
               color: "white", backgroundColor: "#361DDB"
              },
           tContainer: {
                  maxHeight: 730
                },
}));

const NotificationsView = ({ updateTimestamp, onMenuClick, handleOnEdit, handleOnRemove }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [successDialogShow, setSuccessDialogShow] = useState(false);

  const [items, setItems] = useState([]);
const [searchList, setSearchList] = useState([]);

  useEffectAsync(async () => {
        dispatch(showLoaderStateActions.addState(true));

    const response = await fetch('/api/notifications');
          dispatch(showLoaderStateActions.addState(false));

     if (response.ok) {
          const res = await response.json()
          setItems(res);
          setSearchList(res);
        }
  }, [updateTimestamp]);

const searchChange =(val)=>{
    const newItems = items.filter((current)=> {
      const {type} = current;
      let checkval= `${type||''}`;
     checkval = checkval.toLowerCase();
     return checkval.includes(val && val.toLowerCase());
    });
    setSearchList(newItems);
  }

  const reset = ()=> {
    console.log('val');
  }

  const filterItems = searchList.sort((a,b) => new Date(b.creationTime).getTime() - new Date(a.creationTime).getTime());

  const formatList = (prefix, value) => {
    if (value) {
      return value
        .split(/[, ]+/)
        .filter(Boolean)
        .map(it => t(prefixString(prefix, it)))
        .join(', ');
    }
    return '';
  };

  return (
   <>
      <SearchBar
        // value= {'search'}
        onChange={searchChange}
        onCancelSearch={reset}
        placeholder ="Search here..."
        className="searchBarInput"
        style={{ borderRadius:15, height:35, boxShadow: "2px 2px 2px 2px #dbddef", fontSize: 12, marginBottom:'10px', width:"300px"}}
        // onRequestSearch={() => doSomethingWith()}
      />
    <TableContainer className={classes.tContainer} component={Paper}>
    <Table stickyHeader aria-label="sticky table" className={classes.tableAction} size="small" >
      <TableHead>
        <TableRow className={classes.rowAction} >
          <TableCell className={classes.tCell}>{t('notificationType')}</TableCell>
          <TableCell className={classes.tCell}>{t('notificationAlways')}</TableCell>
          <TableCell className={classes.tCell}>{t('sharedAlarms')}</TableCell>
          <TableCell className={classes.tCell}>{t('notificationNotificators')}</TableCell>
          <TableCell className={classes.tCell}>{t('consumer')}</TableCell>
          <TableCell className={classes.tCell}>{t('vendor')}</TableCell>
          <TableCell className={classes.tCell} />
        </TableRow>
      </TableHead>
      <TableBody>
        {filterItems.map((item) => (
          <TableRow
          hover
          key={item.id}
          className={classes.tableRow}>

            <TableCell>{t(prefixString('event', item.type))}</TableCell>
            <TableCell>{formatBoolean(item.always)}</TableCell>
            <TableCell>{formatList('alarm', item.attributes.alarms)}</TableCell>
            <TableCell>{formatList('notificator', item.notificators)}</TableCell>
            <TableCell>{formatBoolean(item.consumer)}</TableCell>
            <TableCell>{formatBoolean(item.vendor)}</TableCell>
            <TableCell className={classes.columnAction} padding="none">
            <div className={classes.iconButtons}>
                                      <Avatar className={classes.small}>
                                      {<IconButton onClick={(event) => handleOnEdit(item.id)}>
                                       <EditIcon fontSize="small" style={{ color: blue[600] }}/>
                                      </IconButton>}
                                      </Avatar>
                                      <Avatar className={classes.small}>
                                      {<IconButton onClick={(event) => handleOnRemove(item.id)}>
                                       <ClearIcon fontSize="small" style={{ color: grey[450] }}/>
                                      </IconButton>}
                                      </Avatar>
                                      </div>
          </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
    </TableContainer>
    </>
  );
}

const NotificationsPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView content={NotificationsView} editPath="/settings/notification" endpoint="notifications"
                    successDialogShow={false}
/>
    </>
  );
}

export default NotificationsPage;
